import React, { useState, useRef } from "react";
import { createPortal } from "react-dom";

// Reusable hover tooltip — ⓘ marker + floating card. Rendered via a portal to <body> so it can
// never be clipped by an ancestor's overflow and never inherits parent text styling (e.g. an
// uppercase label). `placement` = "top" | "bottom" (auto-flips near the top edge).
export function InfoTip({ title, body, accent = "#498DCC", size = 12, placement = "top", testId }) {
  const [tip, setTip] = useState(null); // { left, top, place } | null
  const ref = useRef(null);

  const show = () => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const place = placement === "top" && r.top < 130 ? "bottom" : placement;
    setTip({
      left: r.left + r.width / 2,
      top: place === "bottom" ? r.bottom + 8 : r.top - 8,
      place,
    });
  };
  const hide = () => setTip(null);

  return (
    <span
      ref={ref}
      style={{ position: "relative", display: "inline-flex", alignItems: "center" }}
      onMouseEnter={show}
      onMouseLeave={hide}
    >
      <span style={{ fontSize: size, color: accent, cursor: "help", opacity: 0.75, lineHeight: 1 }} data-testid={testId || "info-tip"}>ⓘ</span>
      {tip && createPortal(
        <span
          style={{
            position: "fixed", left: tip.left, top: tip.top,
            transform: tip.place === "bottom" ? "translate(-50%, 0)" : "translate(-50%, -100%)",
            width: 220, padding: "9px 11px", borderRadius: 11,
            background: "rgba(20,24,28,0.96)", color: "#fff",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            fontSize: 11.5, fontWeight: 400, lineHeight: 1.45, letterSpacing: "normal", textTransform: "none", textAlign: "left",
            zIndex: 99999, boxShadow: "0 10px 28px rgba(0,0,0,0.35)", pointerEvents: "none",
          }}
          data-testid={testId ? `${testId}-pop` : "info-tip-pop"}
        >
          {title && <b style={{ display: "block", marginBottom: 3, fontWeight: 700, textTransform: "none", letterSpacing: "normal" }}>{title}</b>}
          <span style={{ opacity: 0.9 }}>{body}</span>
        </span>,
        document.body
      )}
    </span>
  );
}
